var _a;
import { createDataRecordConverter } from '@core/utils/helpers/enum-converter.helper';
import { ConstructionClass as ClientConstructionType } from '@features/guidbooks/types';
export var constructionTypeMap = createDataRecordConverter((_a = {},
    _a[ClientConstructionType.Wall] = ClientConstructionType.Wall,
    _a[ClientConstructionType.Floor] = ClientConstructionType.Floor,
    _a));
export var convertToServerConstructionTypeData = function (type) {
    return constructionTypeMap.toServer[type];
};
export var convertToClientConstructionTypeData = function (type) {
    return constructionTypeMap.toClient[type];
};
